<template>
  <VSideModal
      :show="show"
      title="هتل تبرک">

    <div class="flex justify-between text-sm">
      <span>اتاق: {{ order.room.number }}</span>
      <span>تلفن: {{ order.user.phone }}</span>
    </div>
    <div class="flex justify-between text-sm mt-2">
      <span>تعداد اقلام: {{ order.items.length }} عدد</span>
      <span>تاریخ: {{ order.created_at }}</span>
    </div>

    <table class="w-full mt-4">
      <thead>
      <tr class="text-muted">
        <td class="p-2 border border-dark-line">محصول</td>
        <td class="p-2 border border-dark-line">تعداد</td>
        <td class="p-2 border border-dark-line">وضعیت</td>
        <td class="p-2 border border-dark-line">مبلغ</td>
      </tr>
      </thead>
      <tbody>
      <tr
          v-for="item in order.items"
          :key="item.id"
          class="text-sm"
          :class="{'line-through' : item.status === 'rejected'}">
        <td class="p-2 border border-dark-line">{{ item.product.name }}</td>
        <td class="p-2 border border-dark-line">{{ item.count }}</td>
        <td class="p-2 border border-dark-line">{{ $helper.renderStatus(item.status) }}</td>
        <td class="p-2 border border-dark-line">{{ $helper.priceFormatter(item.price) }}</td>
      </tr>
      </tbody>
    </table>

    <div class="flex justify-between mt-5 rounded-lg border border-dark-line p-3">
      <span>مبلغ قابل پرداخت:</span>
      <span>{{ $helper.priceFormatter(totalPrice) }}</span>
    </div>

    <VButton class="mt-5 w-full print:hidden" @click="print">پرینت</VButton>

  </VSideModal>
</template>

<script>
import VSideModal from "@/components/General/VSideModal";
import VButton from "@/components/General/VButton";

export default {
  name: "ModalPrintOrder",
  components: {VButton, VSideModal},
  props: ['show', 'order'],
  computed: {
    totalPrice() {
      let totalPrice = 0
      this.order.items.forEach(item => {
        if (item.status !== 'rejected')
          totalPrice += item.price
      })
      return totalPrice
    }
  },
  methods: {
    print() {
      window.print();
    }
  }
}
</script>

<style scoped>

</style>